import styled from "styled-components/macro";
import rem from "../../../../utils/rem";

const SubscribeFormStyled = styled.form`
  width: 100%;
  height: ${rem("42px")};
`;

export default SubscribeFormStyled;
